/**
 * @author <ziad.khoury.hanna@oceandatalab.com>
 * @flow
 */
export const NullComponent /*: React$ComponentType<{}> */ = () => null;
